import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { DataBagService } from '@/common/data-bag.service';
import { AuthError, ErpAuthenticateResult, LoginData, TokenRefreshPayload, TokenRefreshResponse } from './auth.model';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class AuthApiService {
	constructor(
		private readonly dataBagService: DataBagService,
		private readonly httpClient: HttpClient,
	) {}

	token(payload: LoginData): Promise<TokenRefreshResponse> {
		return new Promise((resolve, reject) => {
			this.dataBagService.post('/token/', payload, (result: TokenRefreshResponse, error: AuthError) => {
				if (error) {
					reject(error);
				}
				resolve(result);
			});
		});
	}

	tokenRefresh(payload: TokenRefreshPayload): Promise<TokenRefreshResponse> {
		return new Promise((resolve, reject) => {
			this.dataBagService.post('/token/refresh/', payload, (result: TokenRefreshResponse, error: AuthError) => {
				if (error) {
					reject(error);
				}
				resolve(result);
			});
		});
	}

	// ? php
	erpAuthenticate(token: string): Observable<ErpAuthenticateResult> {
		return this.httpClient.post<ErpAuthenticateResult>(environment.erpUrl + '/auth/token', { token });
	}
}
